import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddProductPage } from '@practium/features/products';
import type { ProductsTab } from '@practium/features/products';
import { ProductModel } from '@practium/features/products/components/3D/ProductModel';

export const AddProductPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as ProductsTab) || 'defensives';
	const id = searchParams.get('id') || undefined;

	const [productName, setProductName] = useState('');
	const [productNature, setProductNature] = useState('');
	const [productManufacturer, setProductManufacturer] = useState('');
	const [productExtra, setProductExtra] = useState('');

	return (
		<AddProductPage
			type={type}
			id={id}
			onBack={() => navigate('/produtos')}
			onIdentifierChange={(name, nature, manufacturer, extra) => {
				setProductName(name);
				setProductNature(nature);
				setProductManufacturer(manufacturer);
				setProductExtra(extra);
			}}
			preview3DSlot={
				<ProductModel
					type={type}
					name={productName}
					nature={productNature}
					manufacturer={productManufacturer}
					extra={productExtra}
				/>
			}
	
		/>
	);
};
